import { Component, ElementRef } from '@angular/core';
import { Router } from '@angular/router';

import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import {
  AuthenticationService,
  AuthenticationState,
  AuthorizationService,
  AuthorizationState,
  IdentityState,
  AccessControlList
} from '@c4/auth';

interface NavItem {
  label: string;
  iconCls: string;
  route?: string;
  accessKey?: string;
  children?: NavItem[];
}

@Component({
  selector: 'cw-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.less'],
  host: {
    '(document:click)': 'onClick($event)',
  }
})
export class NavbarComponent {

  private items: NavItem[] = require('!json-loader!../../assets/config/sidebar.json');
  private itemsObs: Observable<NavItem[]>;

  private authN: Observable<AuthenticationState>;
  private authZ: Observable<AuthorizationState>;
  private identity: Observable<IdentityState>;
  private path: Observable<string>;

  constructor(
    private router: Router,
    private store: Store<{
      identity: IdentityState,
      authentication: AuthenticationState,
      authorization: AuthorizationState,
      router: {
        path: string
      }
    }>,
    private authenticationService: AuthenticationService,
    private authorizationService: AuthorizationService
  ) {
    this.authN = this.store.select(s => s.authentication);
    this.authZ = this.store.select(s => s.authorization);
    this.identity = this.store.select(s => s.identity);
    this.path = this.store.select(s => s.router.path);

    this.itemsObs = Observable.combineLatest(
      this.authZ.filter(a => !!a),
      this.identity.filter(i => !!i),
      (authorization, identity) => this.items
        .filter(item => !item.accessKey || authorization.authorizedFor[item.accessKey])
        .map(it => {

          // The above is passed by value, don't
          // trample the value...
          let item = Object.assign({}, it);

          if (!!item.children) {
            item.children.filter(child => !child.accessKey || authorization.authorizedFor[child.accessKey]);
          }

          if (item.label == 'Programming' && identity.role == 'primary') {
            item.label = 'Personalization';
          }

          return item;
        })
    );
  }

  private logout = () => {
    this.authenticationService.unauthenticate().then(res => {
      this.router.navigate(['/authenticate']);
    });
  }

  private logstate = () => {
    this.store.select(s => s)
      .take(1)
      .subscribe(state => {
        console.info('composer.component.ts: state: %O', state);
      })
  }

  private _showIdent: boolean = false;

  private _toggleIdent = (event: Event) => {
    event.stopPropagation();
    this._showIdent = !this._showIdent;
  }

  private _hideIdent = () => {
    this._showIdent = false;
  }

  // close the drop down menu if the user clicks anywhere
  onClick = (event: MouseEvent) => {
    this._hideIdent();
  }
}



// WEBPACK FOOTER //
// ./src/app/navbar/navbar.component.ts